import { UserAuth } from '@ls-commons/models';
import { routerNavigationAction } from '@ngrx/router-store';
import { createFeature, createReducer, on } from '@ngrx/store';
import { UserActions } from '../actions';
import * as UserSelector from '../selectors';

export interface UsersState {
  result: UserAuth[];
  user: UserAuth | null;
  error: string | null;
  type: string;
}

export const heroesInitialState: UsersState = {
  result: [],
  user: null,
  error: null,
  type: '',
};

export const usersReducer = createReducer<UsersState>(
  heroesInitialState,
  on(
    UserActions.getUsers,
    (state): UsersState => ({
      ...state,
      error: null,
      type: UserActions.getUsers.type,
    })
  ),
  on(
    UserActions.getUsersSuccess,
    (state, { result }): UsersState => ({
      ...state,
      result,
      type: UserActions.getUsersSuccess.type,
    })
  ),
  on(
    UserActions.getUsersFailed,
    (state, { payload }): UsersState => ({
      ...state,
      error: payload,
      result: [],
      type: UserActions.getUsersFailed.type,
    })
  ),

  on(
    UserActions.getUser,
    (state): UsersState => ({
      ...state,
      error: null,
      type: UserActions.getUser.type,
    })
  ),
  on(
    UserActions.getUserSuccess,
    (state, { user }): UsersState => ({
      ...state,
      user,
      type: UserActions.getUserSuccess.type,
    })
  ),
  on(
    UserActions.getUserFailed,
    (state, { payload }): UsersState => ({
      ...state,
      error: payload,
      type: UserActions.getUserFailed.type,
    })
  ),

  on(
    UserActions.deleteUser,
    (state, { user }): UsersState => ({
      ...state,
      user,
      type: UserActions.deleteUser.type,
      error: null,
    })
  ),
  on(
    UserActions.deleteUserSuccess,
    (state): UsersState => ({
      ...state,
      type: UserActions.deleteUserSuccess.type,
    })
  ),
  on(
    UserActions.deleteUserFailed,
    (state, { payload }): UsersState => ({
      ...state,
      error: payload,
      type: UserActions.deleteUserFailed.type,
    })
  ),

  on(
    UserActions.addUser,
    (state, { user }): UsersState => ({
      ...state,
      user,
      error: null,
      type: UserActions.addUser.type,
    })
  ),
  on(
    UserActions.addUserSuccess,
    (state): UsersState => ({
      ...state,
      type: UserActions.addUserSuccess.type,
    })
  ),
  on(
    UserActions.addUserFailed,
    (state, { payload }): UsersState => ({
      ...state,
      error: payload,
      type: UserActions.addUserFailed.type,
    })
  ),

  on(
    UserActions.updateUser,
    (state, { user }): UsersState => ({
      ...state,
      user,
      error: null,
      type: UserActions.updateUser.type,
    })
  ),
  on(
    UserActions.updateUserSuccess,
    (state): UsersState => ({
      ...state,
      type: UserActions.updateUserSuccess.type,
    })
  ),
  on(
    UserActions.updateUserFailed,
    (state, { payload }): UsersState => ({
      ...state,
      error: payload,
      type: UserActions.updateUserFailed.type,
    })
  ),
  on(
    UserActions.clearError,
    (state): UsersState => ({
      ...state,
      error: null,
      type: UserActions.clearError.type,
    })
  ),
  on(routerNavigationAction, (state): UsersState => ({ ...heroesInitialState }))
);

export const userFeature = createFeature({
  name: 'users',
  reducer: usersReducer,
  extraSelectors() {
    return UserSelector.selectors;
  },
});
